export default __webpack_public_path__ + "static/media/allan-project.f26a6a34.PNG";